import styled, { css } from 'styled-components';
import { breakpoint } from '@sketch/global-styles';
import { ReactComponent as ReactComponent$2 } from '@sketch/icons/twitter-24';
import { ReactComponent as ReactComponent$3 } from '@sketch/icons/dribbble-24';
import { ReactComponent as ReactComponent$4 } from '@sketch/icons/instagram-24';
import { ReactComponent } from '@sketch/icons/mail-envelope-16';
import { ReactComponent as ReactComponent$1 } from '@sketch/icons/chat-bubble-16';
import { Text, Grid, Button, LinkButton, Link } from '@sketch/components';

const Wrapper = styled.div `
  display: flex;
`;
const Title = styled.h1 `
  margin: 0;
  font-size: ${({ theme }) => theme.fontSizes.H};
`;
const SubTitle = styled(Text).attrs({
    textStyle: 'copy.quaternary.standard.C',
}) `
  margin-top: 0px;
  margin-bottom: 4px;
  font-weight: ${({ theme }) => theme.fontWeights.semibold};
  text-transform: uppercase;
`;
const Description = styled.p `
  padding: 16px 0;
  color: ${({ theme }) => theme.colors.foreground.secondary.C};
`;
const List = styled.ul `
  padding: 0;
  list-style: none;
`;
const ListItem = styled.li `
  display: flex;
  align-items: center;
  font-size: ${({ theme }) => theme.fontSizes.E};

  :not(:last-child) {
    margin-bottom: 12px;
  }
`;
const StyledColumn = styled(Grid.Column) `
  ${breakpoint('base', 'md') `
    margin-top: 45px;
  `}
`;
const StyledButton = styled(Button) `
  transition: color ${({ theme }) => theme.transitions.duration[1]};

  /** Weird hack to align the text verticaly */
  div {
    line-height: normal; /* stylelint-disable-line scales/line-height */
  }

  :hover {
    color: ${({ theme }) => theme.colors.foreground.secondary.C};
  }
`;
const StyledLinkButton = styled(LinkButton) `
  display: flex;

  /** Weird hack to align the text verticaly */
  div {
    line-height: normal; /* stylelint-disable-line scales/line-height */
  }
`;
const StyledLink = styled(Link) `
  display: inline-flex;
  vertical-align: middle;
`;
const commonIconStyles = css `
  margin-right: 8px;
  vertical-align: middle;
`;
const Email = styled(ReactComponent) `
  width: 16px;
  height: 16px;
`;
const Bubble = styled(ReactComponent$1) `
  width: 16px;
  height: 16px;
`;
const Twitter = styled(ReactComponent$2) `
  width: 18px;
  height: 18px;
  ${commonIconStyles}
`;
const Dribbble = styled(ReactComponent$3) `
  width: 18px;
  height: 18px;
  ${commonIconStyles}
`;
const Instagram = styled(ReactComponent$4) `
  width: 18px;
  height: 18px;
  ${commonIconStyles}
`;
const ActionsContainer = styled.div `
  display: flex;
  align-items: center;
`;
const FooterLink = styled(Link) `
  :hover {
    text-decoration: underline;
  }
`;

export { ActionsContainer, Bubble, Description, Dribbble, Email, FooterLink, Instagram, List, ListItem, StyledButton, StyledColumn, StyledLink, StyledLinkButton, SubTitle, Title, Twitter, Wrapper };
